import { type ComputedRef, type Ref, ref } from 'vue'

export const DISCARD_UNSAVED_TITLE = 'Quitter sans enregistrer ?'
export const DISCARD_UNSAVED_DESCRIPTION = 'Les données saisies seront perdues.'
export const DISCARD_UNSAVED_CONFIRM_TEXT = 'Quitter'
export const DISCARD_UNSAVED_CANCEL_TEXT = 'Annuler'

type UseDiscardUnsavedGuardOptions = {
  isDirty: ComputedRef<boolean>
  onDiscard: () => void
  loading?: Ref<boolean>
}

export function useDiscardUnsavedGuard(options: UseDiscardUnsavedGuardOptions) {
  const showDiscardConfirm = ref(false)

  function requestClose() {
    if (options.loading?.value) return
    if (options.isDirty.value) {
      showDiscardConfirm.value = true
      return
    }
    options.onDiscard()
  }

  function confirmDiscard() {
    if (options.loading?.value) return
    showDiscardConfirm.value = false
    options.onDiscard()
  }

  function cancelDiscard() {
    showDiscardConfirm.value = false
  }

  return {
    showDiscardConfirm,
    requestClose,
    confirmDiscard,
    cancelDiscard,
  }
}
